module.exports = __webpack_public_path__ + "static/building-1c25359a4e33229c638fb2823f087aa6.jpg";